<div class="insurance-mandate-request-item" *ngIf="value" #formContainer>

  <div class="form-table">

    <div class="row">
      <label>Compagnie</label>
      <div>
        <div class="with-error">
          <llc-insurance-provider-select name="insuranceProviderRef"
                                         [ngModel]="value.insuranceProviderRef"
                                         (ngModelChange)="fireUpdate({insuranceProviderRef: $event})"
                                         [required]="true"
                                         [hasError]="validationResults?.propertiesErrors.insuranceProviderRef != null"
                                         [readonly]="disabled"
                                         [includeNoSelectionOption]="false"
                                         [usePublicLabels]="true"
                                         appendTo="body"
          ></llc-insurance-provider-select>
          <div class="error severity-colored"
               *ngFor="let e of validationResults?.propertiesErrors.insuranceProviderRef">
            {{e}}
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <label>Numéro de police</label>
      <div class="with-error">
        <div >
          <input type="text" pInputText
                 name="providerReference"
                 [ngModel]="value.providerReference"
                 (ngModelChange)="fireUpdate({providerReference: $event})"
                 [class.p-state-error]="validationResults?.propertiesErrors.providerReference != null"
                 [readonly]="disabled"
                 [required]="true">
          <div class="hint">
            Le numéro de police est disponible sur votre dernière facture/avis de paiement
          </div>
        </div>
        <div class="error severity-colored" *ngFor="let e of validationResults?.propertiesErrors.providerReference">
          {{e}}
        </div>
      </div>
    </div>


    <div class="row">
      <label>Type de police</label>
      <div class="with-error">
        <div class="category-multi-select ">
          <llc-insurance-category-select name="insuranceCategoryRef"
                                         [ngModel]="value.insuranceCategoryRef || value.providerCategoryName"
                                         (ngModelChange)="onCategoryChanged($event)"
                                         [readonly]="disabled"
                                         [hasError]="validationResults?.propertiesErrors.insuranceCategoryRef != null"
                                         [required]="false"
                                         placeholder="Type de police..."
                                         [usePublicLabels]="true"
                                         [allowStrings]="true"
                                         [includeNoSelectionOption]="false"
                                         appendTo="body"
                                         noSelectionLabel=""
                                         *ngIf="!disabled || value.insuranceCategoryRef != null"
          ></llc-insurance-category-select>
          <div class="hint">
            Type de police mentionné sur votre contrat
          </div>
        </div>
        <div class=" error severity-colored"
             *ngIf="value.insuranceCategoryRef === undefined && value.providerCategoryName == null">
          Valeur requise
        </div>

        <div class="error severity-colored"
             *ngFor="let e of validationResults?.propertiesErrors.insuranceCategoryRef">
          {{e}}
        </div>
        <div class="error severity-colored"
             *ngFor="let e of validationResults?.propertiesErrors.providerCategoryName">
          {{e}}
        </div>
      </div>
    </div>


    <div class="row">
      <label>Preneur d'assurance</label>
      <div>
        <div class="subcriber-type-radio">
          <p-radioButton name="subscriber-type-{{id}}"
                         [value]="true"
                         [ngModel]="value.customerSubscriber"
                         (ngModelChange)="fireCustomerUpdate( $event)"
                         [disabled]="disabled"
                         [label]="'Ma société '+(loggedCustomerName$ | async)"
          ></p-radioButton>
          <p-radioButton name="subscriber-type-{{id}}"
                         [value]="false"
                         [ngModel]="value.customerSubscriber"
                         (ngModelChange)="fireCustomerUpdate( $event)"
                         [disabled]="disabled"
                         label="Une personne physique"
          ></p-radioButton>
        </div>
        <div class="contact-subscriber-type" *ngIf="value.customerSubscriber === false">
          <div>
            <p-radioButton name="contact-subscriber-type-{{id}}"
                           [value]="true"
                           [ngModel]="contactSubscriberIsLoggedContact"
                           [disabled]="disabled"
                           label="Moi même"
            ></p-radioButton>
            <p-radioButton name="contact-subscriber-type-{{id}}"
                           [value]="false"
                           [ngModel]="contactSubscriberIsLoggedContact"
                           label="Quelqu'un d'autre"
                           [disabled]="true"
            ></p-radioButton>
          </div>
          <div class="hint">
            Si vous désirez transférer des polices d'assurances prises par quelqu'un d'autre, veuillez contacter
            LifeisLife
            à <a href="mailto:info@lifeislife.be">info@lifeislife.be</a>.
          </div>
        </div>
      </div>
    </div>


    <div class="row" *ngIf="!disabled || value.nextAnniversaryDate != null">
      <label>Prochaine échéance du contrat</label>
      <div>
        <calendar-input name="next-anniversary"
                        [ngModel]="value.nextAnniversaryDate"
                        (ngModelChange)="fireUpdate({nextAnniversaryDate: $event})"
                        [readonly]="disabled"
                        [hasError]="validationResults?.propertiesErrors.nextAnniversaryDate != null"
                        [minYearDiff]="-1"
                        [maxYearDiff]="2"
                        appendTo="body"
        ></calendar-input>
        <div class="hint">
          Si vous ne connaissez pas cette date, laissez le champ vide
        </div>
      </div>
    </div>

  </div>

  <div class="error severity-colored" *ngFor="let e of validationResults?.errors">
    {{ e }}
  </div>

</div>

